import { Moon, Sun } from "lucide-react";
import type React from "react";
import { useState, useEffect } from "react";

/**
 * A functional component that provides a toggle button for switching between dark and light themes
 */
const ThemeToggle: React.FC = () => {
  // Initialize state based on the current class on the html element
  const [isDarkMode, setIsDarkMode] = useState(true);

  // Effect to initialize the state based on the current theme
  useEffect(() => {
    // const isDark = document.documentElement.classList.contains("dark");

    const isDark =
      document.documentElement.getAttribute("data-theme") === "dark";
    setIsDarkMode(isDark);
  }, []);

  /**
   * Toggles between dark and light mode
   */
  const toggleDarkMode = () => {
    if (isDarkMode) {
      document.documentElement.removeAttribute("data-theme");
    } else {
      document.documentElement.setAttribute("data-theme", "dark");
    }
    setIsDarkMode(!isDarkMode);
  };

  return (
    <button
      type="button"
      onClick={toggleDarkMode}
      className="p-2 rounded-full text-primary"
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDarkMode ? <Sun /> : <Moon />}
    </button>
  );
};

export default ThemeToggle;
